import React from 'react';

/**
 * 二维码登录表单组件
 */
const QrCodeLoginForm = React.memo(() => {
  return (
    <div className='h-[260px] flex flex-col items-center justify-center'>
      <div className='w-48 h-48 bg-gray-100 flex items-center justify-center rounded-lg mb-4'>
        <span className='text-gray-400'>二维码区域</span>
      </div>
      <p className='text-gray-500'>请使用手机扫码登录</p>
      <p className='text-gray-400 text-sm mt-2'>打开手机贯石APP扫一扫登录</p>
    </div>
  );
});

QrCodeLoginForm.displayName = 'QrCodeLoginForm';

export default QrCodeLoginForm;